import { useMemo } from 'react';
import { resolve, type Token } from './container';

export function useResolve<T>(t: Token<T>): T {
  return useMemo(() => resolve(t), [t]);
}
